export const devLogError = (message: string, ...rest: unknown[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.error(message, ...rest);
  }
};
